import { render, staticRenderFns } from "./GiftCard.vue?vue&type=template&id=acd6ec16&scoped=true&"
import script from "./GiftCard.vue?vue&type=script&lang=ts&"
export * from "./GiftCard.vue?vue&type=script&lang=ts&"
import style0 from "./GiftCard.vue?vue&type=style&index=0&id=acd6ec16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd6ec16",
  null
  
)

export default component.exports